(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *   window load
 *   drupal behavior
 *
 *  -------------------------------------------------- */




 /** --------------------------------------------------
    #variables
    -------------------------------------------------- */

	var paragraphProductSliderIsActive = false;
	var paragraphProductSlider;




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {
	});




/** --------------------------------------------------
    #window load
    -------------------------------------------------- */

	$(window).on('load', function() {

		/* setup product slider: */
		/* -> also: code to get the correct teaser heights */
		setupProductSlider();

		$(window).resize(function() {
			setupProductSlider();

			// setupTeaserActionBlocks();
			if(paragraphProductSliderIsActive) {
				$('.flickity-viewport').css('height', '');
				paragraphProductSlider.flickity('resize');
			}
		});

		// setupTeaserActionBlocks();
		if(paragraphProductSliderIsActive) {
			paragraphProductSlider.flickity('resize');
		}
		$(window).trigger('resize');

		/* add "finished" class: */
		$('.paragraph--type-products .product-slider-zone').addClass('js-processed');

		/* empty event listener: */
		/* -> the following is important - it makes flickity work
		*    better on ios
		*    see: https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
		*    "iOS 10 has a bug where event.preventDefault() will not cancel window scrolling. 
		*     You can fix this behavior by adding an innocuous event handler."
		*/
		window.addEventListener('touchmove', function() {});


	});




/** --------------------------------------------------
    #product slider
    -------------------------------------------------- */

	function setupProductSlider() {
		if(productSliderShouldBeActive()) {
			initializeFlickity();
		} else {
			destroyFlickity();
		}
	} /* setupProductSlider */

	function initializeFlickity() {
		let $sliderZone = $(document).find('.paragraph--type-products .product-slider-zone');
		if($sliderZone.length > 0) {
			var $mainSlider = $sliderZone;

			paragraphProductSlider = $mainSlider.find('.field-name-field-products').flickity({
				cellSelector: '.commerce-product--view-mode-teaser',
				setGallerySize: true,
				initialIndex: 0,
				draggable: true,
				pageDots: false,
				prevNextButtons: true,
				wrapAround: true,
				arrowShape: 'M40.3,5.8 46.6,11.6 15.5,45.5 100,45.5 100,54.1 15.5,54.1 46.6,88.5 40.3,94.2 0,49.8 z'
			});

		}

		paragraphProductSliderIsActive = true;
		$('.paragraph--type-products .product-slider-zone').addClass('js-slider-enabled');
	} /* initializeFlickity */

	/* slider helpers */
	/* ************** */

	function productSliderShouldBeActive() {
		var toreturn = false;
		if (window.getComputedStyle) {

			var elementToCheck = document.querySelector('.product-slider-zone');
			if (elementToCheck !== null) {

				var stickyValue = window.getComputedStyle(elementToCheck,':before').getPropertyValue('content');
				stickyValue = stickyValue.replace(/["']/g, "");

				if (stickyValue === "slider") {
					toreturn = true;
				} else {
					toreturn = false;
				}
			}

		}

		return toreturn;
	} /* productSliderShouldBeActive */

	function destroyFlickity() {
		if(paragraphProductSliderIsActive) {
			paragraphProductSlider.flickity('destroy');
			paragraphProductSliderIsActive = false;
			$('.paragraph--type-products .product-slider-zone').removeClass('js-slider-enabled');
		}
	} /* destroyFlickity */


})(jQuery);
